import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import SnackbarContainer from '../../SnackbarContainer';
export default class Container extends Component {
    render() {
        const { style } = this.props;
        return (<View style={[styles.container, style]}>
        {this.props.children}
        <SnackbarContainer ref={c => {
            if (c)
                SnackbarContainer.snackbarInstance = c;
        }}/>
      </View>);
    }
}
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
